import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const ChevronDownLarge: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0684 9.81567C16.1055 9.77849 16.1658 9.77867 16.2031 9.81567C16.2405 9.85283 16.2411 9.91306 16.2041 9.95044L12.002 14.1477L7.79785 9.95044C7.76041 9.91307 7.76035 9.852 7.79785 9.8147C7.8352 9.77788 7.89548 9.77857 7.93262 9.81567L11.4727 13.3528L12.0039 13.8821L12.5332 13.3518L16.0684 9.81567Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
